import { z } from "zod";

export const CreateModelSchema = z.object({
  name: z.string().min(1),
  displayName: z.string().min(1).optional()
});

export type CreateModelInput = z.infer<typeof CreateModelSchema>;
